import React from 'react';
import { Typography, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const LandingPage = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/dashboard');
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.textSection}>
          <Title style={styles.title}>Welcome.</Title>
          <Text style={styles.subtitle}>
            Start analyzing your games and improve your team's performance.
          </Text>
        </div>
        <Button
          type="primary"
          size="large"
          onClick={handleGetStarted}
          style={{
            fontSize: '16px',
            background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '4px',
            transition: 'none', // Remove hover effect
          }}
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
  },
  content: {
    textAlign: 'center',
  },
  textSection: {
    marginBottom: '20px',
  },
  title: {
    fontSize: '70px',
    background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  subtitle: {
    fontSize: '24px',
    background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
};

export default LandingPage;
